XPortal.GridSizing = (function () {
    const self = {
        isGridVisible: function (gridEl) {
            const gridInfo = XPortal.Grid.GetGridInfo(gridEl);
            return gridInfo.parent.length && gridInfo.parent.is(':visible');
        },
        
        getDefaultMinHeight: function (gridEl) {
            const $popupWrapper = gridEl.closest('.modal-body-content');
            return $popupWrapper.length ? 155 : 304;
        },
        
        calculateGridHeight: function (gridEl, gridInfo, defaultMinHeight) {
            const element = self.findGridElement(gridEl);
            const elementPosition = XPortal.Utils.getPosition(element[0]);
            const $sectionWrapper = gridEl.closest('.xsection');
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const windowHeight = document.documentElement.clientHeight;
            const pageFooterHeight = $('.footer').outerHeight();
            let gridHeight = 0;
        
            if ($popupWrapper.length) {
                gridHeight = self.calculatePopupGridHeight($popupWrapper);
            } else {
                gridHeight = windowHeight - elementPosition.top - pageFooterHeight - 4;
            }
        
            if ($sectionWrapper.length && $sectionWrapper.hasClass('maximized')) {
                gridHeight = self.calculateMaximizedSectionGridHeight($sectionWrapper, gridInfo);
            } else {
                gridHeight = self.calculateRegularGridHeight(gridInfo, gridHeight);
            }
        
            gridHeight = self.applyStaticHeight(gridEl, gridHeight);
            gridHeight = self.adjustGridHeight(gridEl, gridInfo, gridHeight, defaultMinHeight);
        
            return gridHeight;
        },
        
        findGridElement: function (gridEl) {
            let element = gridEl.filter(':visible').length ? gridEl : gridEl.next('.entity-list');
            if (!element.length) {
                element = gridEl.closest('.k-pane-wrapper').next('.entity-list');
            }
            return element;
        },
        
        calculatePopupGridHeight: function ($popupWrapper) {
            const contentHeight = self.getElementOuterHeight($popupWrapper.find('.addto-top-content:visible'));
            const smallContentHeight = self.getElementOuterHeight($popupWrapper.find('.addto-top-small-content:visible'));
            return $popupWrapper.outerHeight() - contentHeight - smallContentHeight;
        },
        
        calculateMaximizedSectionGridHeight: function ($sectionWrapper, gridInfo) {
            const $sectionBgwrapper = $sectionWrapper.find('>.xbgdecoration-wrap');
            const blockHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('>.xbgdecoration-wrap>.block-header'));
            const gridHeaderHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
            return $sectionWrapper.height() - self.GetElementVarticalOffset($sectionBgwrapper[0]) - blockHeaderHeight - gridHeaderHeight - 16;
        },
        
        calculateRegularGridHeight: function (gridInfo, gridHeight) {
            const $gridParent = gridInfo.parent;
            const $sectionContentOfGridParent = $gridParent.parent();
            const $gridParentHeightAttr =  parseInt($gridParent.attr('data-height')) || 0;
            const $sectionContentOfGridParentHeightAttr = parseInt($sectionContentOfGridParent.attr('data-height')) || 0;
            const heightAttr = Math.max($gridParentHeightAttr, $sectionContentOfGridParentHeightAttr);
            const isHeightAttrValid = heightAttr > 0;
            const gridheaderHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header')) + 2;
            return isHeightAttrValid ? heightAttr - gridheaderHeight : gridHeight;
        },
        
        applyStaticHeight: function (gridEl, gridHeight) {
            const gridStaticHeightAttr = gridEl.parent('.grid-parent').attr('data-static-height');
            if (gridStaticHeightAttr >= 0) {
                gridHeight = Number(gridStaticHeightAttr);
            }
            return gridHeight;
        },
        
        adjustGridHeight: function (gridEl, gridInfo, gridHeight, defaultMinHeight) {
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $sectionWrapper = gridEl.closest('.xsection');
            const isSectionMaximized = $sectionWrapper.length && $sectionWrapper.hasClass('maximized');
            const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
            const footerHeight = self.getElementOuterHeight(gridInfo.parent.find('.k-grid-footer'));
            let finalHeight = gridHeight;
        
            if (!isSectionMaximized) {
                finalHeight = self.adjustRegularGridHeight(gridEl, gridInfo, gridHeight, headerHeight, footerHeight, defaultMinHeight, $popupWrapper);
            }
        
            finalHeight = self.adjustHeightForSiblingSections(gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo);
        
            if (window.innerWidth <= 768) {
                finalHeight = '60vh';
            }
        
            finalHeight = self.applyStaticHeight(gridEl, finalHeight);
            return finalHeight;
        },
        
        adjustRegularGridHeight: function (gridEl, gridInfo, gridHeight, headerHeight, footerHeight, defaultMinHeight, $popupWrapper) {
            const $halfSizeSection = gridEl.closest('.half-size-grid');
            let finalHeight = gridHeight;
            if ($halfSizeSection.length) {
                 const $nextSectionWrapper = gridInfo.parent.next('.xsection.col-12');
                const pageFooterHeight = $('.footer').outerHeight();
                let sectionHeaderHeight = self.getElementOuterHeight($halfSizeSection.find('>.xbgdecoration-wrap>.block-header'));
                const halfSizeSectionOffset = self.GetElementVarticalOffset($halfSizeSection[0]) + 2 + self.GetElementVarticalOffset($nextSectionWrapper[0]);
                const $gridActionHeader = $halfSizeSection.find('.grid-action-header');
                const gridActionHeaderHeigth = self.getElementOuterHeight($gridActionHeader);
                sectionHeaderHeight += gridActionHeaderHeigth;
                finalHeight = self.calculateHalfSizeGridHeight(gridHeight, headerHeight, pageFooterHeight, sectionHeaderHeight, halfSizeSectionOffset);
            } else {
                const heightAttr = gridInfo.parent.attr('data-height');
                const isHeightAttrValid = typeof heightAttr !== 'undefined' && parseInt(heightAttr) > 0;
                finalHeight = ($popupWrapper.length || isHeightAttrValid ? gridHeight - headerHeight - footerHeight : gridHeight);
            
                if (finalHeight < defaultMinHeight) {
                    finalHeight = defaultMinHeight;
                }
            }
            
            return finalHeight;
        },
        
        calculateHalfSizeGridHeight: function (gridHeight, headerHeight, pageFooterHeight, sectionHeaderHeight, halfSizeSectionOffset) {
            const windowHeight = $(window).height();
            const contentWrapperOffset = self.GetElementVarticalOffset($('.content-wrapper')[0]);

            if (window.matchMedia('(min-width: 1024px)').matches || (window.matchMedia('(orientation: portrait)').matches && window.matchMedia('(max-width: 1023.98px)').matches)) {
                return (windowHeight - headerHeight - pageFooterHeight - contentWrapperOffset) / 2 - sectionHeaderHeight - halfSizeSectionOffset;
            }
            if (window.matchMedia('(max-width: 767px)').matches) {
                return $(window).height() / 2 - 2 * headerHeight - pageFooterHeight - contentWrapperOffset;
            }
            return gridHeight;
        },

        adjustHeightForSiblingSections: function (gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo) {
            const $sectionSiblings = $sectionWrapper.siblings();
            if ($sectionSiblings.length > 0 && XPortal.Utils.getPosition($sectionSiblings[0]).top === XPortal.Utils.getPosition($sectionWrapper[0]).top) {
                const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
                const footerHeight = self.getElementOuterHeight(gridInfo.parent.find('.k-grid-footer'));
                const blockHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('>.xbgdecoration-wrap>.block-header'));
                const blockHeaderOffset = blockHeaderHeight > 0 ? 16 : 0;
                const sectionWrapperOffset = $sectionWrapper.hasClass('remove-paddings') ? 2 : 34;
                gridEl.closest('.grid-parent').css('margin-bottom', $sectionSiblings.find('.comments-wrap').length ? '1rem' : 0);
                finalHeight = $sectionSiblings.height() - headerHeight - footerHeight - blockHeaderHeight - blockHeaderOffset - sectionWrapperOffset;
        
                if ($sectionWrapper.parents().is('.tab-content') && $sectionSiblings.find('.filter-set-summary__items')) {
                    finalHeight = $(window).height() - XPortal.Utils.getPosition(gridEl.closest('.xsection')[0]).top - $('.footer').outerHeight();
                    const gridBlockHeaderHeight = self.getElementOuterHeight(gridEl.closest('.xbgdecoration-wrap').find('> .block-header'));
                    const gridSectionPaddingsOffset = self.GetElementVarticalOffset(gridEl.closest('.xsection').find('>.xbgdecoration-wrap')[0]) + self.GetElementVarticalOffset(gridEl.closest('.xsection')[0]);
        
                    $sectionSiblings.each(function () {
                        const $siblingSectionInTab = $(this);
                        const siblingsBlockHeaderHeight = self.getElementOuterHeight($siblingSectionInTab.find('> .xbgdecoration-wrap > .block-header'));
                        const siblingSectionInTabHeaderHeight = siblingsBlockHeaderHeight ? 0 : gridBlockHeaderHeight;
                        const ssMainSummaryHeight = self.getElementOuterHeight($siblingSectionInTab.find('.dynamic-filter-summary_main'));
                        const ssMainFilterButtonHeight = self.getElementOuterHeight($siblingSectionInTab.find('.dynamic-filter-button-wrp'));
                        const ssMainFiltersHeader = self.getElementOuterHeight($siblingSectionInTab.find('.filter-set-summary__header'));
                        const ssGridSectionPaddingsOffset = $siblingSectionInTab.hasClass('remove-paddings') ? 16 : 32;
                        const ssTotalFiltersHeight = finalHeight - ssMainFiltersHeader - ssMainSummaryHeight - ssMainFilterButtonHeight - ssGridSectionPaddingsOffset + headerHeight + siblingSectionInTabHeaderHeight + gridSectionPaddingsOffset;
        
                        $siblingSectionInTab.find('.filter-set-summary__items')
                            .css({ 'height': ssTotalFiltersHeight, 'overflow': 'auto' })
                            .addClass('custom-scroll-vertical')
                            .removeClass('h-100');
                    }.bind(this));
                }
            }
            return finalHeight;
        },
        
        getElementOuterHeight: function ($element) {
            return $element.length > 0 ? $element.outerHeight() : 0;
        },

        getHiddenElementHeight: function(element) {
            const clonedElement = element.cloneNode(true);
            clonedElement.style.visibility = 'hidden';
            clonedElement.style.position = 'absolute';
            document.body.appendChild(clonedElement);
            const height = clonedElement.offsetHeight;
            document.body.removeChild(clonedElement);
            return height;
        },
        
        setGridHeight: function (gridEl, gridHeight) {
            gridEl.css('height', gridHeight);
        },
        
        adjustListViewHeight: function (gridEl, gridHeight) {
            let $listView = gridEl.next('.entity-list');
            if (!$listView.length) {
                $listView = gridEl.closest('.k-pane-wrapper').next('.entity-list');
            }
            const $listPager = $listView.find('.k-listview-pager');
            if ($listView.length) {
                const contentHeight = gridHeight - ($listView.is('[data-hide-footer="True"]') ? 0 : ($listPager.length ? $listPager.outerHeight() : 0));
                const $listContent = $listView.find('.k-listview-content');
                const listContentScrollClass = gridHeight >= contentHeight - 20 ? 'no-scroll' : 'with-scroll';
                $listContent.css('height', contentHeight).addClass(listContentScrollClass);
                $listView.css('height', gridHeight);
            }
        },
        
        adjustParentHeight: function (gridEl, gridInfo, gridHeight) {
            const $filters = gridInfo.parent.find('.filters-list-wrapper.static');
            const filtersHeight = $filters.length && $filters.is(':visible') ? $filters.outerHeight(true) : 0;
            const parentHeight = gridHeight + filtersHeight;
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $sectionWrapper = gridEl.closest('.xsection');
            const isSectionMaximized = $sectionWrapper.length && $sectionWrapper.hasClass('maximized');
            const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
        
            if (!isSectionMaximized) {
                gridInfo.parent.css('height', ($popupWrapper.length ? parentHeight : parentHeight + headerHeight));
            } else {
                gridInfo.parent.css('height', parentHeight + headerHeight);
            }
        },
        
        adjustSectionContentHeight: function (gridEl) {
            const $sectionWrapper = gridEl.closest('.xsection');
            if ($sectionWrapper.length) {
                $sectionWrapper.children('.section-content').children('.xcontent').css({
                    'min-height': '',
                    'height': ''
                });
            }
        },
        
        resizeKGrid: function (gridInfo) {
            if (gridInfo.kgrid) {
                gridInfo.kgrid.resize();
            }
        },
        
        adjustGridHeaderHeight: function (gridEl) {
            setTimeout(function () {
                if (!gridEl.hasClass('height-resized')) {
                    let gridHeightDiv = 0;
                    const gridHeaderHide = gridEl.data('hide-grid-header') === 'True';
                    if (gridHeaderHide) {
                        const $groupingHeader = gridEl.find('.k-grouping-header');
                        if ($groupingHeader.length) {
                            gridHeightDiv += $groupingHeader.outerHeight();
                        }
                        if (gridEl.closest('.k-pane-wrapper').length) {
                            gridHeightDiv -= 17;
                        }
                        const $gridContent = gridEl.find('.k-grid-content');
                        const $gridContentLocked = gridEl.find('.k-grid-content-locked');
                        $gridContent.height($gridContent.height() + gridHeightDiv);
                        $gridContentLocked.height($gridContentLocked.height() + gridHeightDiv);
                    }
                    gridEl.addClass('height-resized');
                    setTimeout(function () {
                        gridEl.removeClass('height-resized');
                    }, 120);
                }
            }, 100);
        },
        
        adjustRelatedSections: function (gridEl, gridInfo) {
            const gridElId = gridEl.data('id');
            const $relatedSections = $(`[data-parentid="${gridElId}"]`);
            setTimeout(function () {
                $relatedSections.each(function () {
                    const $relatedSectionEl = $(this);
                    self.AdjustRelatedSectionsHeight($relatedSectionEl, gridEl, gridInfo);
                });
            }, 200);
        },

        setInitialHeight: function($element) {
            $element.css({'height': 'initial', 'overflow': 'initial'})
            .removeClass('custom-scroll-vertical')
            .removeClass('h-100');
        },

        setElementHeight: function($element, height) {
            $element.css({'height': height})
            .addClass('custom-scroll-vertical')
            .removeClass('h-100');
        },

        AdjustRelatedSectionsHeight: function ($relatedSection, gridEl, ginfo) {
            const $currentSection = $relatedSection;
            const notAdjust = $currentSection.hasClass('col-12') || $currentSection.find('.xmapviewblock').length > 0;
            if (notAdjust) return;
            const withTabs = $currentSection.find('.nav-tabs').length > 0;
            const tabPane = $currentSection.find('.tab-pane');
            if (tabPane.attr('data-minheight') || tabPane.attr('data-height') || tabPane.attr('data-maxheight')) return;
            const $mainGridSection = gridEl.parents('.grid-parent');
            if ($mainGridSection.hasClass('col-12')) return
            let mainGridSectionHeight = gridEl.parents('.grid-parent').outerHeight(); 
            const topHeaderHeight =  self.getElementOuterHeight($currentSection.find('> .xbgdecoration-wrap > .block-header'));
            const desriptionHeight = self.getElementOuterHeight($currentSection.find('> .xbgdecoration-wrap > .block-header-description'));
            const sectionHeaderHeight = topHeaderHeight + desriptionHeight;
            const $sectionHeightContainer = $currentSection.closest('[data-height]');
            const heightAttr = $sectionHeightContainer.length ? $sectionHeightContainer.attr('data-height') : undefined;
            const withRelatedGrid = $currentSection.find('.grid-parent').length > 0;
            const sectionPaddingsOffset = self.GetElementVarticalOffset($currentSection.find('>.xbgdecoration-wrap')[0]);
            const isCollapsed = $currentSection.hasClass('collapsed');

            if ($sectionHeightContainer.length && (typeof heightAttr !== typeof undefined && heightAttr !== false && parseInt(heightAttr) > 0)) {
                mainGridSectionHeight = parseInt(heightAttr);
            }

            // related sections cases
            const facets = $currentSection.find('.facetfilters-facet-tree').length > 0;
            const facetsList = $currentSection.find('.facetfilters-list-container').length > 0;
            const promouted = $currentSection.find('.filter-set-summary__items').length > 0;
            const comments = $currentSection.find('> .xbgdecoration-wrap > .section-content > .xcontent > .comments-wrap').length > 0;
            const commentsInDetailBlock = $currentSection.find('.detailblock-viewcontainer .comments-wrap').length > 0;

            // promouted filters
            if (promouted) {
                if(isCollapsed) return;
                const filterSearchHeight = self.getElementOuterHeight($currentSection.find('.dynamic-filter-summary_search'));
                const filterApplyButtonHeight = self.getElementOuterHeight($currentSection.find('.dynamic-filter-button-wrp'));
                const filtersHeaderHeight = self.getElementOuterHeight($currentSection.find('.filter-set-summary__header'));
                const sectionBgWrapOffset = self.GetElementVarticalOffset($currentSection.find('> .xbgdecoration-wrap')[0]);
                const sectionPaddingsOfset = self.GetElementVarticalOffset($currentSection[0]);
                const totalFiltersHeight = mainGridSectionHeight - sectionHeaderHeight - filterSearchHeight - filterApplyButtonHeight - filtersHeaderHeight - sectionPaddingsOfset - sectionBgWrapOffset;
                self.setElementHeight($currentSection.find('.filter-set-summary__items-scroll-container'), totalFiltersHeight)
            }

            // facet filters list
            if (facetsList) {
                const sectionPaddingsOfset = $currentSection.hasClass('remove-paddings') ? 0 : 35;
                const totalFiltersHeight = mainGridSectionHeight - sectionPaddingsOfset - sectionHeaderHeight;
                self.setElementHeight( $currentSection.find('.facetfilters-list-container'), totalFiltersHeight)
            }

            //  facet filters tree
            if (facets) {
                const totalFiltersHeight = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset;
                self.setElementHeight(  $currentSection.find('.facetfilters-facet-tree'), totalFiltersHeight)
            }

            // comments
            if (comments && !commentsInDetailBlock) {
                const $commentsWrap = $currentSection.find('> .xbgdecoration-wrap > .section-content > .xcontent > .comments-wrap')
                const $commentsInput = $commentsWrap.find('.comments-cntbc > .cmnt-edit-form');
                const commentsInputCalcHeight = isCollapsed ? 78 : self.getElementOuterHeight($commentsInput) + 32;
                const commentsInputHeight = $commentsInput.hasClass('cmnt-edit-form_bottom') ? commentsInputCalcHeight - 10 : commentsInputCalcHeight;
                const commentsSummaryHeight = self.getElementOuterHeight($commentsWrap.find('.comments-cntbc__summary'));
                const commentsHeight = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset -  commentsInputHeight - commentsSummaryHeight;
                self.setInitialHeight($currentSection.find('.xbgdecoration-wrap'));
                self.setElementHeight($commentsWrap.find('.comment-items'), commentsHeight)
            } 
            
            // comments in detail block
            if (commentsInDetailBlock) {
                const $commentsWrap = $currentSection.find('.detailblock-viewcontainer .comments-wrap');
                const detaiPageHeaderHeight = self.getElementOuterHeight($currentSection.find('.block-header_entity-detail'));
                const parentsection = $commentsWrap.closest('.xdetailssection');
                const commentsInDetailBlockSiblings = parentsection.siblings('.xdetailssection');
                const $commentsWrapSection = $commentsWrap.closest('.xsection');
                const commentsWrapSectionOffset = $commentsWrapSection.hasClass('remove-paddings') ? 2 : 48;
                const commentsHeight = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset - commentsWrapSectionOffset - detaiPageHeaderHeight;
                if (commentsInDetailBlockSiblings.length == 0) {
                    $currentSection.find('.xbgdecoration-wrap')
                        .css('height', "initial")
                        .removeClass('custom-scroll-vertical')
                        .addClass('h-100');
                    self.setElementHeight($currentSection.find('.comments-wrap'), commentsHeight)
                }
            }

            // related section with tabs
            if (withTabs) {
                const tabsNavHeight = $currentSection.find('.nav-tabs').length > 0 ? $currentSection.find('.nav-tabs').outerHeight() : 0;
                $currentSection.find('> .xbgdecoration-wrap > .section-content').addClass('section-content_with-tabs')
                const sectionPaddingsOfset = $currentSection.hasClass('remove-paddings') ? 3 : 35;
                self.setInitialHeight($currentSection.find('.xbgdecoration-wrap'));
                self.setInitialHeight($currentSection.find('.filter-set-summary__items'));
                const totalTabContebntHeight = mainGridSectionHeight - sectionHeaderHeight - tabsNavHeight - sectionPaddingsOfset;
                self.setElementHeight($currentSection.find('.tab-content'), totalTabContebntHeight)

                // in case only one grid added to tab
                const $relatedGridParent = $currentSection.find('.grid-parent');
                const gridSection = $relatedGridParent.closest('.xdetailssection');
                const gridSectionSinlings = gridSection.siblings('.xdetailssection');
                const dragAndDropGrid = self.getElementOuterHeight($currentSection.find('.dropzone-container'));
                if ($relatedGridParent.length > 0 && gridSectionSinlings.length == 0) {
                    const gridElToResize = $relatedGridParent.find('.entity-grid');
                    const gridFooterHeigth = gridElToResize.find('.k-grid-pager').length > 0 ? gridElToResize.find('.k-grid-pager').outerHeight() : 0;
                    const tabOfset = 40;
                    const gridPaddingBottom = 30;
                    const actionsHeigth = $currentSection.find('> .xbgdecoration-wrap > .section-content .grid-action-header').outerHeight();
                    const updatedStatikGridHeigth = totalTabContebntHeight - sectionPaddingsOfset - actionsHeigth - gridFooterHeigth - tabOfset - dragAndDropGrid - gridPaddingBottom;
                    const gridInfo = XPortal.Grid.GetGridInfo(gridElToResize);
                    $relatedGridParent.attr('data-static-height', updatedStatikGridHeigth);
                    $relatedGridParent.addClass('static-heigth-aplied');
                    self.adjustParentHeight(gridElToResize, gridInfo, updatedStatikGridHeigth);
                    self.setGridHeight(gridElToResize, updatedStatikGridHeigth)
                    self.resizeKGrid(gridInfo);
                }
            }

            // in case the dragAndDrop and grid in related section
            if (withRelatedGrid) {
                const $relatedGridParent = $currentSection.find('> .xbgdecoration-wrap > .section-content .grid-parent');
                const $currentSectionWrp = $currentSection.find('> .xbgdecoration-wrap');
                const $detailSection = $relatedGridParent.closest('.xdetailssection');
                const $detailSectionBgElem = $relatedGridParent.closest('.xdetailssection').find('>.xbgdecoration-wrap');
                const detailOffset = self.GetElementVarticalOffset($currentSectionWrp[0]) + self.GetElementVarticalOffset($detailSection[0]) + self.GetElementVarticalOffset($detailSectionBgElem[0]);
                const dragAndDropGrid = self.getElementOuterHeight($currentSection.find('.dropzone-container')) + 16;
                const gridElToResize = $relatedGridParent.find('.entity-grid');
                const $gridActionHeader = $relatedGridParent.find('.grid-action-header');
                const gridActionHeaderHeigth = isCollapsed  ? self.getHiddenElementHeight($gridActionHeader[0]) : self.getElementOuterHeight($gridActionHeader);
                const updatedStatikGridHeigth = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset - gridActionHeaderHeigth - dragAndDropGrid - detailOffset;
                const gridInfo =  XPortal.Grid.GetGridInfo(gridElToResize);
                $relatedGridParent.attr('data-static-height', updatedStatikGridHeigth).addClass('static-heigth-aplied');
                self.adjustParentHeight(gridElToResize, gridInfo, updatedStatikGridHeigth);
                self.setGridHeight(gridElToResize, updatedStatikGridHeigth)
                self.resizeKGrid(gridInfo);
            }

            // regular related section
            if (!withTabs && !facets && !facetsList && !promouted && !comments) {
                const contentHeight = mainGridSectionHeight;
                const $sectionBgwrapper = $currentSection.find('>.xbgdecoration-wrap');
                const $sectionVerticalofset = self.GetElementVarticalOffset($currentSection[0]);
                self.setElementHeight($sectionBgwrapper, contentHeight - $sectionVerticalofset)
                // clear height for all inner sections
                $sectionBgwrapper.find('.xbgdecoration-wrap')
                    .css({ 'height': 'auto', 'overflow': 'initial' })
                    .removeClass('custom-scroll-vertical')
                    .removeClass('h-100');
            }
        },
        GetElementVarticalOffset: function (element) {
            if (!element) {
                return 0;
            }   
            
            const computedStyle = window.getComputedStyle(element);
        
            const paddingTop = parseFloat(computedStyle.getPropertyValue('padding-top')) || 0;
            const paddingBottom = parseFloat(computedStyle.getPropertyValue('padding-bottom')) || 0;
            const marginTop = parseFloat(computedStyle.getPropertyValue('margin-top')) || 0;
            const marginBottom = parseFloat(computedStyle.getPropertyValue('margin-bottom')) || 0;
            const borderTopWidth = parseFloat(computedStyle.getPropertyValue('border-top-width')) || 0;
            const borderBottomWidth = parseFloat(computedStyle.getPropertyValue('border-bottom-width')) || 0;
        
            return paddingTop + paddingBottom + marginTop + marginBottom + borderTopWidth + borderBottomWidth;
        },
    }

    return self;
}());
